import { GameModal } from './GameModal';
import { COLORS, SHADOWS, LABELS, RULES } from '@/game/configs';
interface HowToPlayOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}
export function HowToPlayOverlay({ isOpen, onClose }: HowToPlayOverlayProps) {
  return (
    <GameModal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-6">
        <h2
          className="text-2xl font-extrabold text-center"
          style={{ color: COLORS.dark }}
        >
          {LABELS.howToPlay}
        </h2>
        <div className="flex flex-col gap-4">
          {RULES.map((rule, index) => (
            <div
              key={index}
              className="flex items-start gap-3"
            >
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: COLORS.yellow }}
              >
                <span
                  className="text-xs font-bold"
                  style={{ color: COLORS.dark }}
                >
                  {index + 1}
                </span>
              </div>
              <p
                className="text-sm leading-relaxed"
                style={{ color: COLORS.brown }}
              >
                {rule}
              </p>
            </div>
          ))}
        </div>
        <button
          onClick={onClose}
          className="w-full py-4 rounded-2xl font-bold text-lg transition-all duration-150 active:scale-98 mt-2"
          style={{
            backgroundColor: COLORS.yellow,
            color: COLORS.dark,
            boxShadow: SHADOWS.soft,
          }}
        >
          {LABELS.gotIt}
        </button>
      </div>
    </GameModal>
  );
}